import chips from "../../games/chips";
import coin from "../../../../assets/gold_coin.svg";

function CurrentChip(chipsValues, betValue) {
    const betArr = chipsValues.split(",").map(Number);

    const updatedChips = chips.map((item, i) => {
        return betArr[i] ? { ...item, val: betArr[i] } : item;
    });

    for (let i = 0; i < betArr.length - 1; i++) {
        if (betArr[i] <= betValue && betArr[i + 1] > betValue) {
            return updatedChips[i].src;
        }
    }

    if (betValue >= betArr[betArr.length - 1]) {
        return updatedChips[betArr.length - 1].src;
    }

    return coin;
}

const UM = { CurrentChip };
export default UM;
